import cn from 'classnames'
import React from 'react'
export interface PaginationProps {
  postsPerPage: number
  totalPosts: number
  paginate: (num: number) => void
  paginateFront: () => void
  paginateBack: () => void
  currentPage: number
  className?: string
}
export const Pagination: React.FC<PaginationProps> = ({
  postsPerPage,
  totalPosts = 0,
  paginate,
  paginateFront,
  paginateBack,
  currentPage,
  className,
  ...props
}) => {
  const pageNumbers = []

  for (
    let i = Math.max(1, currentPage - 2);
    i <= Math.min(Math.ceil(totalPosts / postsPerPage), currentPage + 2);
    i++
  ) {
    pageNumbers.push(i)
  }

  return (
    <>
      {totalPosts > 0 && (
        <div className={cn(className, 'flex flex-row justify-between items-center py-2')} {...props}>
          <div className="flex md:flex-row flex-col w-full justify-between items-center py-2">
            <nav className="block">
              <ul className="flex pl-0 rounded list-none flex-wrap">
                <li>
                  <div
                    onClick={() => {
                      paginateBack()
                    }}
                    className={
                      currentPage === 1
                        ? 'relative inline-flex items-center px-2 py-2  bg-white text-[0.8125rem] font-primary font-medium text-[#bebfc2] hover:bg-gray-50 '
                        : 'relative inline-flex items-center px-2 py-2  bg-white text-[0.8125rem] font-primary font-medium text-textdark cursor-pointer hover:bg-gray-50 '
                    }
                  >
                    <span className="">Previous Page</span>
                  </div>
                  {pageNumbers.map((number) => (
                    <div
                      key={number}
                      onClick={() => {
                        paginate(number)
                      }}
                      className={
                        currentPage === number
                          ? 'underline underline-offset-4 text-[0.8125rem] text-textdark font-primary hover:bg-blue-200 relative inline-flex items-center  px-2 py-2   font-medium cursor-pointer'
                          : ' text-[0.8125rem] text-textdark font-primary hover:bg-blue-200   relative inline-flex items-center  px-2 py-2   font-medium cursor-pointer'
                      }
                    >
                      {number}
                    </div>
                  ))}
                  <div
                    onClick={() => {
                      paginateFront()
                    }}
                    className={
                      currentPage === pageNumbers[pageNumbers.length - 1]
                        ? 'relative inline-flex items-center px-2 py-2  bg-white text-[0.8125rem] font-primary font-medium text-[#bebfc2] hover:bg-gray-50'
                        : 'relative inline-flex items-center px-2 py-2  bg-white text-[0.8125rem] font-primary font-medium text-textdark cursor-pointer hover:bg-gray-50'
                    }
                  >
                    <span className="">Next Page</span>
                  </div>
                </li>
              </ul>
            </nav>
            <div>
              <p className="text-[0.8125rem] font-primary text-shade md:mt-0 mt-[10px]">
                <span className="font-medium">{currentPage * postsPerPage - postsPerPage + 1}</span>-
                <span className="font-medium"> {Math.min(currentPage * postsPerPage, totalPosts)} </span>
                of
                <span className="font-medium"> {totalPosts} </span>
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
